import { useState } from 'react';

export const useForm = (initialState) => {
    const [state, setState] = useState(initialState);

    // Función para manejar cambios en campos de texto y archivos de imagen
    const onChange = (event, field) => {
        if (!event?.target) {
            setState({
                ...state,
                [field]: event
            });
            return;
        }
        
        if (event.target.type === 'file') {
            const file = event.target.files[0];
            const reader = new FileReader();
            reader.onloadend = () => {
                setState({
                    ...state,
                    [field]: reader.result // Guardamos la imagen como base64
                });
            };
            if (file) {
                reader.readAsDataURL(file);
            }
        } else {
            setState({
                ...state,
                [field]: event.target.value
            });
        }
    };

    const resetForm = () => {
        setState(initialState);
    };

    return {
        ...state,
        form: state,
        onChange,
        resetForm,
        setState
    };
};